import {
  Facebook,
  Github,
  Globe,
  Instagram,
  Link2,
  Linkedin,
  Mail,
} from 'lucide-react';

const YoutubeIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M23.5 6.2a3 3 0 00-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 00.5 6.2 31.5 31.5 0 000 12a31.5 31.5 0 00.5 5.8 3 3 0 002.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 002.1-2.1A31.5 31.5 0 0024 12a31.5 31.5 0 00-.5-5.8zM9.75 15.5v-7l6.5 3.5-6.5 3.5z" />
  </svg>
);
const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.6 3.3A4.9 4.9 0 0116.9 0h-3.5v16.4c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1.3 0 .6 0 .9.1V9.8a7.5 7.5 0 00-.9-.1 6.7 6.7 0 00-6.7 6.7 6.7 6.7 0 006.7 6.7 6.7 6.7 0 006.7-6.7V8.1a8.3 8.3 0 004.9 1.6V6.2a4.9 4.9 0 01-3.3-2.9z" />
  </svg>
);

const TelegramIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const ViberIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M11.4 0C9.5.1 5.7.8 3.1 3.4S.1 9.5 0 11.4c0 .8.2 2 .5 2.9l-1 3.7 3.8-1c.9.3 1.9.5 2.8.5h.1c1.9-.1 5.7-.8 8.3-3.4s3.3-6.4 3.4-8.3c0-.9-.2-1.9-.5-2.8l1-3.8-3.7 1c-.9-.3-1.8-.5-2.7-.5h-.4zm.1 2.1h.3c.8 0 1.6.2 2.3.4l.6.2-.7 2.5.5.3c.2.2.4.4.6.7.4.6.7 1.3.7 2.1-.1 1.5-.7 4.5-2.7 6.5s-5 2.6-6.5 2.7c-.8 0-1.5-.3-2.1-.7-.3-.2-.5-.4-.7-.6l-.3-.5 2.5-.7-.2-.6c-.2-.7-.4-1.5-.4-2.3 0-1.9.7-5.7 3.3-8.3s6.4-3.3 8.3-3.3z" />
  </svg>
);

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const ThreadsIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.536-8.373-4.129-2.124-2.697-3.149-6.462-3.036-10.878.107-4.284 1.605-7.687 4.354-10.11C7.99.942 11.14 0 14.816 0h.007c3.576.024 6.32 1.536 8.373 4.129 2.124 2.697 3.149 6.462 3.036 10.878-.107 4.284-1.605 7.687-4.354 10.11C19.01 23.058 15.86 24 12.184 24zM8.895 19.658c.775.48 1.675.734 2.658.734.982 0 1.882-.254 2.657-.734 1.55-.96 2.454-2.78 2.454-4.97 0-2.19-.904-4.01-2.454-4.97-.775-.48-1.675-.734-2.657-.734-.983 0-1.883.254-2.658.734-1.55.96-2.454 2.78-2.454 4.97 0 2.19.904 4.01 2.454 4.97z" />
  </svg>
);

const PinterestIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
  </svg>
);

const VkIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M15.684 0H8.316C1.592 0 0 1.592 0 8.316v7.368C0 22.408 1.592 24 8.316 24h7.368C22.408 24 24 22.408 24 15.684V8.316C24 1.592 22.408 0 15.684 0zm3.692 17.123h-1.744c-.66 0-.862-.525-2.05-1.727-1.033-1-1.49-1.135-1.744-1.135-.356 0-.458.102-.458.593v1.575c0 .424-.135.678-1.253.678-1.846 0-3.896-1.118-5.335-3.202C4.624 10.857 4 8.57 4 8.096c0-.254.102-.491.593-.491h1.744c.44 0 .61.203.78.677.847 2.49 2.27 4.675 2.856 4.675.22 0 .322-.102.322-.66V9.721c-.068-1.186-.695-1.287-.695-1.71 0-.203.17-.407.44-.407h2.744c.373 0 .508.203.508.643v3.473c0 .372.17.508.271.508.22 0 .407-.136.813-.542 1.27-1.422 2.18-3.608 2.18-3.608.119-.254.322-.491.763-.491h1.744c.525 0 .644.27.525.643-.22 1.017-2.354 4.031-2.354 4.031-.186.305-.254.44 0 .78.186.254.796.779 1.203 1.253.745.847 1.32 1.558 1.473 2.05.17.49-.085.744-.576.744z" />
  </svg>
);

export const SOCIAL_ICON_LABELS = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  telegram: 'Telegram',
  whatsapp: 'WhatsApp',
  viber: 'Viber',
  linkedin: 'LinkedIn',
  github: 'GitHub',
  twitter: 'X',
  threads: 'Threads',
  pinterest: 'Pinterest',
  vk: 'VK',
  mail: 'Email',
  website: 'Website',
  link: 'Link',
};

export const SOCIAL_ICON_COMPONENTS = {
  instagram: Instagram,
  facebook: Facebook,
  tiktok: TikTokIcon,
  youtube: YoutubeIcon,
  telegram: TelegramIcon,
  whatsapp: WhatsAppIcon,
  viber: ViberIcon,
  linkedin: Linkedin,
  github: Github,
  twitter: XIcon,
  threads: ThreadsIcon,
  pinterest: PinterestIcon,
  vk: VkIcon,
  mail: Mail,
  website: Globe,
  link: Link2,
};

/** Messengers — contacts / CTA, not footer icon row. */
export const DIRECT_MESSAGE_ICONS = ['viber', 'telegram', 'whatsapp'];

function isUsableSocialUrl(url) {
  const value = String(url || '').trim();
  return Boolean(value) && value !== '#';
}

/** @param {import('@/types/cms').SocialLinkItem[]} links */
export function resolveSocialLinks(links) {
  if (!Array.isArray(links)) return [];

  return links
    .filter((item) => item?.url && isUsableSocialUrl(item.url))
    .map((item) => ({
      icon: item.icon,
      url: item.url,
      label: item.label || SOCIAL_ICON_LABELS[item.icon] || item.icon,
      Icon: SOCIAL_ICON_COMPONENTS[item.icon] || Link2,
    }));
}

/**
 * Public networks for footer / Social Links Bar (excludes Viber/Telegram/WhatsApp).
 *
 * @param {import('@/types/cms').SocialLinkItem[]} links
 */
export function resolveFooterSocialLinks(links) {
  return resolveSocialLinks(links).filter((item) => !DIRECT_MESSAGE_ICONS.includes(item.icon));
}

/**
 * Direct-message channels for CTA / Contacts (not Instagram/Facebook/etc.).
 *
 * @param {import('@/types/cms').SocialLinkItem[]} links
 * @param {import('@/types/cms').SocialLinks} [social]
 */
export function resolveDirectMessageLinks(links, social = {}) {
  const fromLinks = resolveSocialLinks(links).filter((item) => DIRECT_MESSAGE_ICONS.includes(item.icon));
  if (fromLinks.length) {
    return fromLinks;
  }

  return DIRECT_MESSAGE_ICONS
    .map((icon) => {
      const url = social[icon];
      if (!isUsableSocialUrl(url)) {
        return null;
      }
      return {
        icon,
        url,
        label: SOCIAL_ICON_LABELS[icon] || icon,
        Icon: SOCIAL_ICON_COMPONENTS[icon] || Link2,
      };
    })
    .filter(Boolean);
}

/** Legacy `social` object → link list. */
export function socialObjectToLinks(social) {
  if (!social || typeof social !== 'object') return [];

  return Object.entries(social)
    .filter(([, url]) => url)
    .map(([icon, url]) => ({
      icon,
      url,
      label: SOCIAL_ICON_LABELS[icon] || icon,
      Icon: SOCIAL_ICON_COMPONENTS[icon] || Link2,
    }));
}
